import React from 'react';
import { useSelector } from 'react-redux';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';

import { createTheme } from 'config/theme';
import { ApplicationState } from 'store/store';
import { ErrorBoundary } from './ErrorBoundary';
import { SnackbarProviderWrapper } from './SnackbarProviderWrapper';

// Create emotion cache with higher specificity
const cache = createCache({
    key: 'emotion-css'
});

interface AppWrapperProps {
    children: React.ReactNode;
}

export function AppWrapper(props: AppWrapperProps) {
    const { children } = props;
    const { layout } = useSelector((state: ApplicationState) => state.layout);
    const { merchantId } = useSelector((state: ApplicationState) => state.settings);
    const theme = React.useMemo(() => createTheme(merchantId ?? '', layout), [layout, merchantId]);
    return (
        <CacheProvider value={cache}>
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={theme}>
                    <CssBaseline />
                    <SnackbarProviderWrapper>
                        <ErrorBoundary>{children}</ErrorBoundary>
                    </SnackbarProviderWrapper>
                </ThemeProvider>
            </StyledEngineProvider>
        </CacheProvider>
    );
}
